export interface IIncomeType {
  label: string;
  value: string;
}

export const incomeTypes: IIncomeType[] = [
  { value: 'FullTime', label: 'Full Time' },
  { value: 'PartTime', label: 'Part Time' },
  { value: 'Self Employed', label: 'Self Employed' },
  { value: 'Contract', label: 'Contract' },
  { value: 'Student', label: 'Student' },
  { value: 'Unemployed', label: 'Unemployed' },
  { value: 'Other', label: 'Other' },
];

export const otherIncomeSources: IIncomeType[] = [
  { value: 'Other', label: 'Other' },
  { value: 'RentalProperty', label: 'Rental Property' },
  { value: 'ChildSupport', label: 'Child Support' },
  { value: 'Retirement', label: 'Retirement' },
  { value: 'Military', label: 'Military' },
  { value: 'Disability', label: 'Disability' },
  { value: 'VaBenefits', label: 'Va Benefits' },
  { value: 'SocialSecuritySsi', label: 'Social Security Ssi' },
  { value: 'EmploymentIncome', label: 'Employment Income' },
];
